import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WebStore } from "interfaces";
import { RootState } from "redux/store";
import { PREFIX } from "./helper";
import { initialState } from "./initial-state";
import { createSessionId } from "./session-id";

export const webStoreSlice = createSlice({
	name: PREFIX,
	initialState,
	reducers: {
		loadData: (state, action: PayloadAction<WebStore>) => {
			state.store = action.payload;
		},
		generateSessionId: (state, action: PayloadAction<string | undefined>) => {
			if (action.payload) {
				state.sessionId = action.payload;
				return;
			}

			if (!state.sessionId) {
				state.sessionId = createSessionId();
			}
		}
	}
});

export const { loadData, generateSessionId } = webStoreSlice.actions;

export const selectWebStoreState = (state: RootState) => state.webStore;
export default webStoreSlice.reducer;
export * from "./initializer";
export * from "./types";
